import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TSelectionValue } from "@ts/common-types";
import { RowNode } from "ag-grid-community";

const isRuleFiltersAppliedSlice = createSlice({
    name: "isRuleFiltersApplied",
    initialState: { value: false },
    reducers: {
        updateIsRuleFiltersApplied: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const mainGridFiltersSlice = createSlice({
    name: "mainGridFilters",
    initialState: { value: {} },
    reducers: {
        updateMainGridFilters: (
            state,
            action: PayloadAction<TSelectionValue | object>
        ) => {
            state.value = action.payload;
        },
    },
});

const poGridFiltersSlice = createSlice({
    name: "poGridFilters",
    initialState: { value: {} },
    reducers: {
        updatePoGridFilters: (
            state,
            action: PayloadAction<TSelectionValue | object>
        ) => {
            state.value = action.payload;
        },
    },
});

const caGridFiltersSlice = createSlice({
    name: "caGridFilters",
    initialState: { value: {} },
    reducers: {
        updateCaGridFilters: (
            state,
            action: PayloadAction<TSelectionValue | object>
        ) => {
            state.value = action.payload;
        },
    },
});

const adGridFiltersSlice = createSlice({
    name: "adGridFilters",
    initialState: { value: {} },
    reducers: {
        updateAdGridFilters: (
            state,
            action: PayloadAction<TSelectionValue | object>
        ) => {
            state.value = action.payload;
        },
    },
});

const pdGridFiltersSlice = createSlice({
    name: "pdGridFilters",
    initialState: { value: {} },
    reducers: {
        updatePdGridFilters: (
            state,
            action: PayloadAction<TSelectionValue | object>
        ) => {
            state.value = action.payload;
        },
    },
});

const portfolioFiltersSlice = createSlice({
    name: "portfolioFilters",
    initialState: { value: {} },
    reducers: {
        updatePortfolioFilters: (
            state,
            action: PayloadAction<TSelectionValue | object>
        ) => {
            state.value = action.payload;
        },
    },
});

const campaignFiltersSlice = createSlice({
    name: "campaignFilters",
    initialState: { value: {} },
    reducers: {
        updateCampaignFilters: (
            state,
            action: PayloadAction<TSelectionValue | object>
        ) => {
            state.value = action.payload;
        },
    },
});

const adgroupFiltersSlice = createSlice({
    name: "adgroupFilters",
    initialState: { value: {} },
    reducers: {
        updateAdgroupFilters: (
            state,
            action: PayloadAction<TSelectionValue | object>
        ) => {
            state.value = action.payload;
        },
    },
});

const keywordFiltersSlice = createSlice({
    name: "keywordFilters",
    initialState: { value: {} },
    reducers: {
        updateKeywordFilters: (
            state,
            action: PayloadAction<TSelectionValue | object>
        ) => {
            state.value = action.payload;
        },
    },
});

const placementFiltersSlice = createSlice({
    name: "placementFilters",
    initialState: { value: {} },
    reducers: {
        updatePlacementFilters: (
            state,
            action: PayloadAction<TSelectionValue | object>
        ) => {
            state.value = action.payload;
        },
    },
});

const productFiltersSlice = createSlice({
    name: "productFilters",
    initialState: { value: {} },
    reducers: {
        updateProductFilters: (
            state,
            action: PayloadAction<TSelectionValue | object>
        ) => {
            state.value = action.payload;
        },
    },
});

const checkedNodeSlice = createSlice({
    name: "checkedNode",
    initialState: { value: [] },
    reducers: {
        updateCheckedNode: (state, action: PayloadAction<RowNode[]>) => {
            state.value = action.payload;
        },
    },
});

const poCheckedNodeSlice = createSlice({
    name: "poCheckedNode",
    initialState: { value: [] },
    reducers: {
        updatePoCheckedNode: (state, action: PayloadAction<RowNode[]>) => {
            state.value = action.payload;
        },
    },
});

const caCheckedNodeSlice = createSlice({
    name: "caCheckedNode",
    initialState: { value: [] },
    reducers: {
        updateCaCheckedNode: (state, action: PayloadAction<RowNode[]>) => {
            state.value = action.payload;
        },
    },
});

const adCheckedNodeSlice = createSlice({
    name: "adCheckedNode",
    initialState: { value: [] },
    reducers: {
        updateAdCheckedNode: (state, action: PayloadAction<RowNode[]>) => {
            state.value = action.payload;
        },
    },
});

const pdCheckedNodeSlice = createSlice({
    name: "pdCheckedNode",
    initialState: { value: [] },
    reducers: {
        updatePdCheckedNode: (state, action: PayloadAction<RowNode[]>) => {
            state.value = action.payload;
        },
    },
});

const poFilterCountSlice = createSlice({
    name: "poFilterCount",
    initialState: { value: {} },
    reducers: {
        updatePoFilterCount: (
            state,
            action: PayloadAction<Record<string, number | string>>
        ) => {
            state.value = action.payload;
        },
    },
});

const caFilterCountSlice = createSlice({
    name: "caFilterCount",
    initialState: { value: {} },
    reducers: {
        updateCaFilterCount: (
            state,
            action: PayloadAction<Record<string, number | string>>
        ) => {
            state.value = action.payload;
        },
    },
});

const adFilterCountSlice = createSlice({
    name: "adFilterCount",
    initialState: { value: {} },
    reducers: {
        updateAdFilterCount: (
            state,
            action: PayloadAction<Record<string, number | string>>
        ) => {
            state.value = action.payload;
        },
    },
});

const pdFilterCountSlice = createSlice({
    name: "pdFilterCount",
    initialState: { value: {} },
    reducers: {
        updatePdFilterCount: (
            state,
            action: PayloadAction<Record<string, number | string>>
        ) => {
            state.value = action.payload;
        },
    },
});

export const { updateIsRuleFiltersApplied } = isRuleFiltersAppliedSlice.actions;
export const { updateMainGridFilters } = mainGridFiltersSlice.actions;
export const { updatePoGridFilters } = poGridFiltersSlice.actions;
export const { updateCaGridFilters } = caGridFiltersSlice.actions;
export const { updateAdGridFilters } = adGridFiltersSlice.actions;
export const { updatePdGridFilters } = pdGridFiltersSlice.actions;

export const { updatePortfolioFilters } = portfolioFiltersSlice.actions;
export const { updateCampaignFilters } = campaignFiltersSlice.actions;
export const { updateAdgroupFilters } = adgroupFiltersSlice.actions;
export const { updateKeywordFilters } = keywordFiltersSlice.actions;
export const { updateProductFilters } = productFiltersSlice.actions;
export const { updatePlacementFilters } = placementFiltersSlice.actions;
export const { updateCheckedNode } = checkedNodeSlice.actions;
export const { updatePoCheckedNode } = poCheckedNodeSlice.actions;
export const { updateCaCheckedNode } = caCheckedNodeSlice.actions;
export const { updateAdCheckedNode } = adCheckedNodeSlice.actions;
export const { updatePdCheckedNode } = pdCheckedNodeSlice.actions;

export const { updatePoFilterCount } = poFilterCountSlice.actions;
export const { updateCaFilterCount } = caFilterCountSlice.actions;
export const { updateAdFilterCount } = adFilterCountSlice.actions;
export const { updatePdFilterCount } = pdFilterCountSlice.actions;

export const isRuleFiltersAppliedReducer = isRuleFiltersAppliedSlice.reducer;
export const mainGridFiltersReducer = mainGridFiltersSlice.reducer;
export const poGridFiltersReducer = poGridFiltersSlice.reducer;
export const caGridFiltersReducer = caGridFiltersSlice.reducer;
export const adGridFiltersReducer = adGridFiltersSlice.reducer;
export const pdGridFiltersReducer = pdGridFiltersSlice.reducer;

export const portfolioFiltersReducer = portfolioFiltersSlice.reducer;
export const campaignFiltersReducer = campaignFiltersSlice.reducer;
export const adgroupFiltersReducer = adgroupFiltersSlice.reducer;
export const keywordFiltersReducer = keywordFiltersSlice.reducer;
export const productFiltersReducer = productFiltersSlice.reducer;
export const placementFiltersReducer = placementFiltersSlice.reducer;
export const checkedNodeReducer = checkedNodeSlice.reducer;
export const poCheckedNodeReducer = poCheckedNodeSlice.reducer;
export const caCheckedNodeReducer = caCheckedNodeSlice.reducer;
export const adCheckedNodeReducer = adCheckedNodeSlice.reducer;
export const pdCheckedNodeReducer = pdCheckedNodeSlice.reducer;

export const poFilterCountReducer = poFilterCountSlice.reducer;
export const caFilterCountReducer = caFilterCountSlice.reducer;
export const adFilterCountReducer = adFilterCountSlice.reducer;
export const pdFilterCountReducer = pdFilterCountSlice.reducer;
